import { ADD_VEHICLE_OVERVIEW, EXIT_VEHICLE_CONFIGURATION } from "../actionTypes";
import Action from './models/action';
import { VehicleInformation } from "../../components/main/motorcycles/MotorcycleView";
import { VehicleOverviewResponse } from "../../components/main/overview/Overview";
import { Part } from "../../components/parts/PartsList";

export interface VehicleOverviewState extends VehicleOverviewResponse {
    Vehicle: VehicleInformation;
    Categories: string[];
};

const VehicleState: VehicleInformation = {
    Name: '',
    ModelId: '',
    EngineType: '',
    Hero: {
        Intro: '',
        Title: '',
        ImageUrl: '',
        Description: '',
        Price: {
            CurrencySymbol: '',
            Value: 0,
        }
    }
}

export const vehicleInitialState: VehicleOverviewState = {
    Vehicle: VehicleState,
    FastFacts: [],
    Setups: [],
    Categories: [],
    Parts: [],
}

export function getCategoryInformation(parts: Part[]): string[] {
    return parts.reduce((acc: string[], current: Part) => {
        return acc.includes(current.CategoryName) ? acc : [...acc, current.CategoryName];
    }, []).sort();
}

export default function VehicleOverviewReducer(state: VehicleOverviewState = vehicleInitialState, action: Required<Action>): VehicleOverviewState {
    switch (action.type) {
        case ADD_VEHICLE_OVERVIEW: {
            return {
                ...action.payload,
            }
        }
        case EXIT_VEHICLE_CONFIGURATION: {
            return {
                ...vehicleInitialState,
            };
        }
        default:
            return state;
    }
}